import {
    PropsWithChildren,
    createContext,
    FC,
    useState,
    useCallback,
} from 'react'

export interface NavigationConfigType {
    /** set to true to hide the nav wrapper when set to true */
    noNavWrapper?: boolean
    /** the title text to be shown in the top nav */
    navTitle?: string
    /** set to true if you want the nav wrapper to scroll child content */
    scroll?: boolean
    /** set to true if you want to display the workbench ops top navigation */
    showOpsNav?: boolean
    /** sets the active sidebar nav item */
    sidebar?: string
}

export const DEFAULT_NAV_CONFIG: NavigationConfigType = {
    noNavWrapper: false,
    navTitle: undefined,
    scroll: false,
    showOpsNav: false,
    sidebar: undefined,
}

export const NavigationContext = createContext<{
    navigationConfig: NavigationConfigType
    setNavigationConfig: (config: NavigationConfigType) => void
}>({
    navigationConfig: DEFAULT_NAV_CONFIG,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setNavigationConfig: () => {},
})

export const NavigationConfigProvider: FC<PropsWithChildren<unknown>> = ({
    children,
}) => {
    const [navigationConfig, setNavConfig] = useState<NavigationConfigType>({
        ...DEFAULT_NAV_CONFIG,
        noNavWrapper: true,
    })

    const setNavigationConfig = useCallback(
        (newConfig: NavigationConfigType) => {
            setNavConfig({
                ...DEFAULT_NAV_CONFIG,
                ...newConfig,
            })
        },
        [setNavConfig],
    )

    return (
        <NavigationContext.Provider
            value={{ navigationConfig, setNavigationConfig }}
        >
            {children}
        </NavigationContext.Provider>
    )
}
